import { useHistory, useLocation } from 'react-router-dom'
import { MODALS } from '../constants'
import { getModalLocation } from '../lib/modal'

/**
 * A hook to add/remove selected content item
 */
export const useMyList = () => {
  const history = useHistory()
  const location = useLocation()

  const addToMyList = (renderedInComponent) => {
    return (contentItem) => {
      history.push(getModalLocation(
        location,
        MODALS.qsParams.addContentToLists,
        {
          contentItemId: contentItem.id,
          renderedInComponent
        },
        {
          contentItem
        }
      ))
    }
  }

  return {
    allItems: [],
    addToMyList
  }
}
